import styled from "style/styled-components";
import ImageWithPlaceholder from "components/generic/ImageWithPlaceholder";

const ListImage = styled(ImageWithPlaceholder)`
  width: 190px;
  height: 120px;
`;

export default ListImage;
